export default axios => ({
    getList(payload) {
        return axios.get('/complex-exercises/list', payload)
    },
    getComplex(id) {
        return axios.get(`/complex-exercises/${id}`)
    },
    delete(id) {
        return axios.delete(`/complex-exercises/delete/${id}`)
    },
    create(payload) {
        return axios.post('/complex-exercises/create', payload);
    },
    edit(payload) {
        return axios.patch(`/complex-exercises/${payload.id}`, payload);
    },
    getHumanSystemTypes() {
        return axios.get('/human-system-type')
    }
})
